<template>
  <AppForm label="配信曜日時間帯設定">
    <v-btn @click="isActiveEditForm = true">変更</v-btn>
    <v-layout v-for="(day, dIndex) in days" :key="dIndex" class="pl-4 mb-2">
      <v-flex xs2>
        <h4>
          {{ day.ja }}
        </h4>
      </v-flex>
      <v-flex xs10>
        <div v-if="formedValue[day.en].length === 0" style="color:red;">
          配信停止
        </div>
        <div v-for="(range, index) in formedValue[day.en]" :key="index">
          {{ range.startHour }}：00 〜 {{ range.endHour }}：59
        </div>
      </v-flex>
    </v-layout>
    <EditModal
      v-model="isActiveEditForm"
      :settings="formedValue"
      :days="days"
      :use-only-one-day="useOnlyOneDay"
      @change="change($event)"
    />
  </AppForm>
</template>

<script>
import EditModal from './FormAdvancedWeeklyModalEdit'
const DAYS = [
  {
    ja: '月曜日',
    en: 'monday',
  },
  {
    ja: '火曜日',
    en: 'tuesday',
  },
  {
    ja: '水曜日',
    en: 'wednesday',
  },
  {
    ja: '木曜日',
    en: 'thursday',
  },
  {
    ja: '金曜日',
    en: 'friday',
  },
  {
    ja: '土曜日',
    en: 'saturday',
  },
  {
    ja: '日曜日',
    en: 'sunday',
  },
]
export default {
  components: { EditModal },
  props: {
    value: {
      // WeeklyDeliveryScheduleModel
      type: Array,
      default: () => [],
    },
    useOnlyOneDay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActiveEditForm: false,
    }
  },
  computed: {
    days() {
      return this.useOnlyOneDay ? [{ ja: '配信時間帯', en: 'schedule' }] : DAYS
    },
    formedValue() {
      let result = {}
      this.days.forEach(d => {
        result[d.en] = []
      })
      this.value.forEach(schedule => {
        const day = this.useOnlyOneDay ? 'schedule' : schedule.day
        result[day].push({
          day,
          startHour: Number(schedule.startHour),
          endHour: Number(schedule.endHour),
        })
      })
      return result
    },
  },
  methods: {
    change(result) {
      this.$emit('input', result)
    },
  },
}
</script>
